
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.73 4.083a.73.73 0 1 1-1.46 0 .73.73 0 0 1 1.46 0zM14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0zm-1.167 0A5.84 5.84 0 0 0 7 1.167 5.84 5.84 0 0 0 1.167 7 5.84 5.84 0 0 0 7 12.833 5.84 5.84 0 0 0 12.833 7zM5.25 5.833V7h1.167v3.5h1.166V5.833H5.25z","fill":"#FFF","opacity":".5"}})])
          )
        }
      }
    